import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, TextField, Button, Alert, Box } from "@mui/material";
import axios from "../../axios";

export default function AcceptInvite() {
  const [params]   = useSearchParams();
  const navigate   = useNavigate();
  const token      = params.get("token") ?? "";

  const [password, setPassword]   = useState("");
  const [confirm, setConfirm]     = useState("");
  const [error, setError]         = useState(null);
  const [success, setSuccess]     = useState(false);
  const [saving, setSaving]       = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setSaving(true);
    setError(null);
    axios.post("/team/accept-invite", { token, password, password_confirmation: confirm })
      .then(() => { setSuccess(true); setTimeout(() => navigate("/exact/store-login"), 2500); })
      .catch(e => setError(e.response?.data?.message ?? "Something went wrong."))
      .finally(() => setSaving(false));
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Box sx={{ p: 4, border: "1px solid #ebebeb", borderRadius: 2, background: "#fff" }}>
        <h2 style={{ marginTop: 0 }}>Accept Invitation</h2>
        <p style={{ color: "#555", fontSize: 14 }}>Set a password to activate your account.</p>

        {success ? (
          <Alert severity="success">Account activated! Redirecting to login…</Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, mb: 3 }}>
              {error && <Alert severity="error">{error}</Alert>}
              <TextField label="Password" type="password" fullWidth
                InputLabelProps={{ shrink: true }}
                value={password} onChange={e => setPassword(e.target.value)} required />
              <TextField label="Confirm Password" type="password" fullWidth
                InputLabelProps={{ shrink: true }}
                value={confirm} onChange={e => setConfirm(e.target.value)} required />
            </Box>
            <Button type="submit" variant="contained" fullWidth disabled={saving || !token}
              sx={{ background: "#1a6b9a" }}>
              {saving ? "Activating…" : "Activate Account"}
            </Button>
            {!token && (
              <Alert severity="warning" sx={{ mt: 2 }}>Invalid or missing invite token.</Alert>
            )}
          </form>
        )}
      </Box>
    </Container>
  );
}
